export default {
  lang: 'UK English',
  homeScreen: {
    title: '', // Product specific
    stayConnected: 'Stay Connected',
    comingSoon: 'Coming Soon',
    messages: 'Messages',
    subtitle: '',
  },
  glassWidgets: {
    errors: {
      requestFailed: 'Something went wrong. Please try again later.',
    },
    programStatus: {
      title: 'My Status',
      loading: 'Loading…',
      yourRep: 'Your Rep',
      myProfile: 'My Profile',
      favorites: 'Favorites',
      registeredOn: 'Joined on:',
      graduatedOn: 'Graduated on:',
      totalBadgesEarned: 'Total Badges Earned:',
      lastBookingLogged: 'Last Booking Logged:',
      currentTier: 'Current Tier',
      lastBadgeEarned: 'Last Badge Earned:',
      currentFocus: 'Current Focus:',
      changeProfilePicture: 'Change Profile Picture',
    },
    todaysfocus: {
      title: "Today's Focus",
      empty: 'No focus items for today',
      loading: 'Loading…',
      error: 'Something went wrong',
      slideNavAria: 'Slide navigation',
      slideAria: 'Slide',
      carouselAria: "Today's focus",
    },
    welcome: 'Welcome!',
    welcomeBack: 'Welcome back, {firstName}!',
    notifications: {
      loading: 'Loading…',
      empty: 'No notifications',
    },
    achievements: {
      title: 'Rewards & Contests',
      loading: 'Loading…',
      lastBooking: 'Last Entry Submission',
      currentTier: 'Current Tier',
      contestEntries: 'Total Contest Entries',
      nightsBooked: 'Nights Booked',
      totalRevenue: 'Total Revenue Reported',
      noBookingData: 'No booking data available.',
      notAvailable: 'N/A',
      fileUploadSuccess: 'File has been uploaded successfully.',
      quickSubmit: {
        title: 'Quick submit',
        uploading: 'Uploading…',
        clear: 'Clear',
        submit: 'Submit',
        submitSuccessSimulated: 'Booking submitted successfully',
      },
    },
  },
  notification: {
    newAndNow: 'New & Now!',
    alert: 'Alert',
    message: 'Message',
    badge: 'New Badge',
    contest: 'Contest',
    'content-update': 'Content Update',
    events: 'Events',
    other: 'Notification',
    welcome: 'Welcome',
  },
  loginScreen: {
    version2custom: {
      defaultAmbassador: {
        step2: 'Step 1: Create an Account',
        step3: 'Step 2: Create Your Profile',
      },
      houstonInsider: {
        hospitalityCheckboxLabel:
          'This program is currently limited to hospitality employees based in Houston. While we hope to expand eligibility in the future, please note that participants who do not meet the current requirements may be subject to removal from the program',
      },
      app1857: {
        fields: {
          howDiscoveredKLA: 'How did you discover the Key Lime Academy?',
          tradeshowDetailLabel: 'Which tradeshow or conference?',
          tradeshowDetailPlaceholder: 'Please enter the name of the show or conference',
          discoverVisitFloridaKeys: 'Visit Florida Keys website',
          discoverSearchEngine: 'Search Engine (e.g. Google, Yahoo)',
          discoverAiTool: 'AI tool/search (e.g. ChatGPT, Perplexity)',
          discoverSocialMedia: 'Social Media (e.g. Instagram, X, Facebook, LinkedIn)',
          discoverEmailNewsletter: 'Email or Newsletter',
          discoverWordOfMouth: 'Word of Mouth',
          discoverTradeshowConference: 'Tradeshow or Conference (please tell us which show)',
          discoverOtherTravproAffiliate: 'Other affiliate TravPRO sites',
        },
      },
      app1865: {
        fields: {
          topTravelType: 'What is the #1 type of travel you sell?',
          travelTypeAdventure: 'Adventure/Soft Adventure/Expedition',
          travelTypeAllInclusive: 'All Inclusive',
          travelTypeBusinessMice: 'Business/MICE',
          travelTypeCultureExperiential: 'Culture/Experiential',
          travelTypeCruise: 'Cruise',
          travelTypeFamilyMultiGen: 'Family/Multi Generational',
          travelTypeRomance: 'Romance/Wedding/Honeymoon',
          travelTypeLuxury: 'Luxury',
          travelTypeRail: 'Rail',
          travelTypeTours: 'Tours',
          travelTypeWellness: 'Wellness/Health/Spa',
          travelTypeLgbtq: 'LGBTQ+',
        },
      },
      app1826: {
        fields: {
          optMarketing: "Stay connected to this programme's travel trade team and partners and receive updates.",
        },
      },
      app842: {
        fields: {
          segments: 'Which segment(s) do you primarily sell?',
          segmentLeisure: 'Leisure',
          segmentCorporate: 'Corporate',
          segmentGroup: 'Group',
        },
      },
    },
    version2: {
      homeTitle: "Let's see if we can find an existing profile for you in our system.",
      homeTitleSub: 'Enter the email address you typically use to log in to training programmes.',
      noAccount: 'No account found ({email}), please try with another email or create an account now.',
      continueButton: 'Continue',
      success: 'Successfully updated your account! You will be redirected shortly to the home page.',
      successNewAccount: 'To complete your registration, you will receive a confirmation email to verify your account.',
      loginButton: 'Login',
      matchFound: 'We have found a match, please fill in your password to continue.',
      magicLink: 'Login via a link in your email:',
      magicLinkButton: 'Request Magic Link',
      magicLinkTitle: 'Get a direct link sent to your email that will sign you in instantly.',
      otherEmailButton: 'Submit',
      title:
        'Please take a moment to complete all the information below as it will populate your personal profile and contact information.',
      titleIndustry:
        'Please take a moment to complete all the information below as it will populate your personal profile and contact information.',
      register: 'Create an account',
      agent: 'Travel Adviser',
      visitor: 'Industry Visitor',
      ambassador: 'Ambassador',
      step1: 'Step 1: Type of User',
      step2: 'Step 2: Create An Account',
      step3: 'Step 3: Create Your Profile',
      marketingOptIn: 'Are you sure you are not interested in staying connected to this programme’s travel trade team?',
      optIn: 'Yes, I’m Interested',
      optOut: 'Not Interested',
      step2Sub1: 'Tell Us About Yourself',
      step2Sub2: 'Tell Us About Your Business',
      step2Sub3: 'Tell Us About Your Employer',
      privacyHead: 'COMMUNICATIONS PREFERENCES',
      privacySub:
        'Check the boxes below to ensure you receive important communications from the supplier’s travel trade team (product updates and announcements, rewards, incentives, FAMs, etc.) and travel trade networking and sales support initiatives from TravPRO Mobile.',
      privacy: 'We protect your privacy and never sell, misuse or betray your trust.',
      store: 'Easily download this programme at your app store:',
      powered: 'POWERED BY',
      toastMessage: {
        forgotSuccess:
          'We have emailed your password reset link! You will be redirected to the login page in 10 seconds.',
        emailNotExisting: "The email address you entered doesn't exist.",
        magicLinkMessage: 'Please wait, we are signing you in right now.',
        magicLinkError:
          "We couldn't find your account in our database, please log in manually. You will be redirected in 10 seconds.",
        magicLinkError1:
          "We couldn't find a valid token, please log in or request a new magic link. If this problem persists, please contact us at: info@travpromobile.com.",
        magicLinkError2:
          "We couldn't find your account in our database, please log in manually. You will be redirected in 10 seconds.",
        magicLinkSuccess: "Check your email at {email}. It has a magic link that'll sign you in.",
        magicLinkErrorWait: 'Please wait 5 minutes in between magic link requests.',
        emailNotFoundError:
          'The email address you entered can’t be found in our records. Please check for misspellings or create an account.',
      },
      errors: {
        zipCodeNotFound: 'Postcode not found, try again',
        zipCodeOnlyNumbers: 'Postcode can only contain numbers',
        password: 'Please enter a password',
        passwordNotMatching: 'The passwords you entered do not match',
        passwordTooShort: 'Password needs to be at least 8 characters',
        emailExists:
          'This email address already exists or is invalid. Please try with another email address or log in to your account.',
        fillInAllFields: 'Please fill in all the required fields',
        fillInEmail: 'Please fill in your email.',
        emailNotExisting: "The email address you entered doesn't exist.",
      },
      fields: {
        forgotSubCopy: 'Forgot your password & want to change it? ',
        forgotSubCopy2:
          'Want to bypass password entirely? We will send you an email with a magic link that will automatically log you into the programme. ',
        city: 'City',
        companyName: 'Company Name',
        role: 'Your Role',
        description: "Which best describes your company's business?",
        country: 'Country',
        password: 'Password',
        passwordRegister: 'Choose Password (8 character minimum)',
        passwordConfirm: 'Confirm Password',
        firstName: 'First Name (Given)',
        lastName: 'Last Name (Family)',
        agency: 'Your Agency Name',
        employer: 'Employer Business Name',
        employerRole: 'Which Best Describes Your Role?',
        employerYears: 'How many years have you been local to the area you work?',
        title: 'Your Role (Select One)',
        company: 'Company Name',
        select: 'Select an option below',
        state: 'State',
        province: 'Province/Region/State',
        zipCode: 'Postcode',
        postalCode: 'Postal Code',
        affiliate: 'Which group is your MAIN agency affiliation?',
        hostAgency: 'Your Host Agency?',
        ataCliaArc: 'What is your ATA/CLIA/ARC number?',
        executive: 'Executive',
        management: 'Management',
        marketing: 'Marketing',
        sales: 'Sales',
        coordinator: 'Coordinator',
        invalidEmail: 'Please enter a valid email address',
        roleDMO: 'DMO',
        roleEventEmployee: 'Event Employee',
        roleHotelEmployee: 'Hotel Employee',
        roleRestaurantBar: 'Restaurant/Bar Employee',
        roleRetailService: 'Retail and Service Employee',
        roleTourActivity: 'Tour and Activity Operator Employee',
        roleTransportation: 'Transportation Employee',
        roleOther: 'Other',
        yearsJustArrived: 'Just arrived (<6 months)',
        years1to5: '1 to 5 Years',
        years5to10: '5 to 10 Years',
        years10Plus: '10+ Years',
        opt: "Stay connected to this programme's travel trade team and receive updates.",
        optMarketing: 'Stay connected to TravPRO regarding similar programmes and events.',
        retail: 'Retail Store Front',
        home: 'Home-Based Agent',
        independent: 'Independent Contractor',
        host: 'Host Agency',
        call: 'Call Centre or Web-Based Agency',
        other: 'Other ',
        describes: 'What best describes you and your agency’s business? ',
      },
    },
    title: 'Travel Professional Training and Sales Enablement Programme', // Product specific (TravPRO text or ChannelPRO text)
    welcome: {
      headerTop: 'Welcome to',
    },
    sellingPoints: {
      // All selling points can be product specific
      0: 'Learn, Promote & Sell on the Go',
      1: 'Multimedia Training Across Devices',
      2: 'Certificate of Completion',
      3: 'Ready-made Sales Presentations',
      4: 'High-impact Promotional Materials',
      5: 'Insider Tips & Promotions',
      6: 'Real-time Product Directory',
      7: 'Timely News & Updates',
    },
    emailPrompt: 'Please enter your email address and password to confirm that you are a travel professional.', // Product specific (TravPRO or ChannelPRO text)
    tAndC: {
      agree: 'By continuing you agree with our ',
      privacyPolicy: 'privacy policy',
      and: ' and ',
      termsConditions: 'terms and conditions',
    },
    fields: {
      what: 'What type of travel do you sell?',
      what1: 'What is the #1 type of travel you sell?',
      what2: 'What is the #2 type of travel you sell?',
      what3: 'What is the #3 type of travel you sell?',
      agency: 'Agency *',
      email: 'Email',
      password: 'Password',
      passwordConfirm: 'Confirm your password *',
      firstName: 'First name *',
      lastName: 'Last name *',
      agencyName: 'Agency Name *',
      city: 'City *',
      stateProvince: 'State / Province *',
      salutation: 'Salutation *',
      required: 'Required',
      invalidEmail: 'Invalid email address',
      complete: 'Step 2: Complete your profile',
      tell: 'Tell Us About Yourself',
      title: 'Business Title *',
      host: 'Host Agency Name',
      country: 'Country / Region',
      select: 'Please select an option below',
      header2: 'Which segment(s) do you primarily sell?',
      step2: 'Describe Your Business',
      leisure: 'Leisure',
      corporate: 'Corporate',
      group: 'Group',
      affiliate: 'What is Your Main Affiliation?',
      forgot: 'Forgot your password? Click the button below and we’ll send you an email to reset your password.',
    },
    noAgent: {
      noAgentButton: "I'm not an adviser",
      title: 'Thank you for your interest in\n{clientName}', // Product specific
      messageWeb:
        'The content on this site is exclusively for travel professionals.\nTo learn more about {clientName}, please visit: ', // Product specific
      messageMobile:
        "Some content on this app is exclusively for travel professionals, but feel free to browse a preview of what this app has to offer by pressing 'Continue'.", // Product specific
      continue: 'Continue',
      visitWebsite: 'Visit website',
    },
    newUser: 'New User',
    register: 'Register',
    registered: 'This email is already registered',
    forgot: 'Reset Password',
    header:
      'Please take a moment to complete all the information below, as this is what will populate your profile and contact information.',
    step1: 'Step 1: Complete your email address and choose a password.',
  },
  welcomeScreen: {
    helloUser: 'Hello {{name}}',
    hello: 'Hello,',
    fromAgency: 'from {{agency}}',
    notUser: 'Not {{name}}?',
    introOnline: "Train immediately online or preload the content so it's always available for offline use!",
    introOffline: 'You already have the latest version preloaded. Start training or selling anytime, anywhere!',
    startTraining: 'Start learning',
    continueTraining: 'Continue learning',
    graduated: 'Congratulations!',
    downloader: {
      preload: 'Preload',
      stop: 'stop',
      init: 'Initialising...',
      lastUpdate: 'Last update: ',
    },
  },
  trainingScreens: {
    start: 'Start',
    continue: 'Continue',
    review: 'Review',
    restart: 'Restart',
    durationInMinutes: '{number} minutes',
    percentageComplete: '{number}% Complete',
    comingSoon: 'New Chapter Coming Soon',
    unlock: 'Unlock this chapter by completing chapter {number}.',
    unlockFoundation: 'Unlock this chapter by completing chapter {number}.',
    unlockSpecialization: 'Unlock by earning your certificate.',
    unlockPartners: 'Unlock by earning your certificate.',
    unlockRetain: 'Unlock this chapter by completing the foundation in {name}.',
    unlockSubtitle: 'Unlock more chapters by completing chapters.',
    allUnlocked: 'You have unlocked all chapters!',
    certificate: 'Certificate',
    courseComplete: 'Continue',
    endReached: "You've reached the end",
    retainEnd: 'Use the top bar to navigate around in this chapter or press the back button to return to the overview.',
    watchListenRead: 'Watch, Listen & Read more',
    trouble: "It looks like you're having trouble, please re-read the content on the previous page(s) and try again.",
    confirm: 'Confirm your answer',
    choose: 'Please choose an answer',
    skip: 'Return >',
    viewAllTitle: 'Training Tip',
    viewAll:
      'To proceed to the next page, please be sure to review all content on the page. This may include watching all videos, clicking the icons to view supplementary materials, and answering question pages correctly. This helpful information has been provided to enhance your training and ensure you achieve PRO status.',
    fillBlanks: 'Fill in the blank(s):',
    next: 'Next question',
    retry: 'Try Again',
    fastTrackContinue: 'Continue Fast Track',
    fastTrackMoveToFull: 'Cancel Fast Track',
    fastTrackPrompt:
      'Do you consider yourself a BVI expert already? Would you like to attempt to Fast Track your certification? One attempt, 15 questions, need 80% (B) passing grade.',
    grading: 'Your final grade is: {grade}',
  },
  nav: {
    home: 'Home',
    train: 'Train',
    learn: 'Learn',
    retain: 'Retain',
    directory: 'Directory',
    showRoom: 'Showcases',
    showcases: 'Showcases',
    destinationShowcases: 'Destination\nShowcases',
    offers: 'Offers',
    promote: 'Promote',
    sell: 'Sell',
    info: 'Info',
    rewards: 'Rewards',
    achievements: 'Achievements',
    media: 'Media',
    favorites: 'Favourites',
    contact: 'Meet the Team',
    reportCard: 'View Diploma',
    accountSettings: 'Account Settings',
    changeProfileImage: 'Change Profile Image',
    messages: 'Messages',
    search: 'Search',
    manageImpersonation: 'Impersonate User',
  },
  impersonateView: {
    title: 'Impersonate user',
    description:
      'Enter the email address of the user you want to impersonate. You must already be authenticated for impersonation to work.',
    returnToApp: 'Return to app',
    emailLabel: 'Email address',
    startImpersonation: 'Start impersonation',
    impersonating: 'Impersonating…',
    confirmImpersonation: 'Confirm impersonation',
    confirming: 'Confirming…',
    endImpersonation: 'End impersonation',
    ending: 'Ending…',
    currentlyImpersonating: 'Currently impersonating {email}. You can end impersonation below.',
    missingEmail: 'Please enter an email address to impersonate.',
    tokenFetched: 'Impersonation token fetched for {email}. Reviewing profile before confirming.',
    previewFailed: 'Failed to fetch user profile for impersonation.',
    startFailed: 'Failed to start impersonation. Please try again.',
    confirmFailed: 'Failed to confirm impersonation. Please try again.',
    endFailed: 'Failed to end impersonation. Please try again.',
    previewLabel: 'Impersonation response',
  },
  contentHeaders: {
    train: 'Train',
    learn: 'Learn',
    retain: 'Retain',
    subapps: ' Partner MicroLearning Modules',
    subAppsFull: ' PARTNER SALES COMPANIONS',
    maintrainings: 'The Foundation',
    subtrainings: 'Specializations',
    fastTrack: 'Fast Track',
  },
  pageDescriptions: {
    train: 'Educate, engage and become the expert.',
    trainAmbassador: 'Educate, engage, and become an expert ambassador.',
    showroom: '',
    retain:
      'Welcome to Retain. After completing your training, this will be your your go-to resource for retaining your expert knowledge and enabling your sales efforts. Use this area to expertly answer a product question or even as an impromptu sales presentation — anytime, anywhere and from any device.',
    retainAmbassador:
      'Welcome to Retain. After completing your training, this will be your your go-to resource for retaining your expert knowledge and enabling your sales efforts. Use this area to expertly answer a product question or even as an impromptu sales presentation — anytime, anywhere and from any device.',
    promote: 'Share these items to ignite interest and start a conversation with clients and prospects.',
    promoteAmbassador:
      'Here you’ll find resources to keep you up to date on tourism essentials, as well as interesting items to share with visitors and help them experience the best of the destination.',
    sell: 'Answer client questions and close the sale like a pro with deep resources and targeted sales support.',
    favorites: 'Check out your personally favourited content',
    search: 'Look through all content',
    subapps: 'Earn a Specialist Badge by completing these quick single-chapter partner modules.',
    subAppsFull: 'Achieve full expert status by getting to know our partners',
    maintrainings: 'Complete these essential modules to earn your certificate.',
    subtrainings: 'Enhance your expertise and earn a badge for each specialization module below.',
    fastTrack: 'You are currently in the fast track. Complete it to earn your grade!',
  },
  general: {
    chapter: 'Chapter',
    next: 'Next',
    yes: 'Yes',
    no: 'No',
    previous: 'Previous',
    submit: 'Submit',
    back: 'Back',
    close: 'Close',
    page: 'Page',
    search: 'Search',
    selectLanguage: 'Select language',
    logIn: 'Log in',
    logOut: 'Log Out',
    viewItem: 'View {type}',
    imageNotFound: 'Image not found',
    noResultsFor: 'No results have been found for {query}',
    noFavorites: "You don't have any favourites yet.",
    noMessages: "You haven't received any messages yet!",
    resultsFor: 'Results for: {{query}}',
    showAll: 'Show all',
    connectionError: 'Connection error',
    alreadyExists: 'Already exists',
    pageNotFound: '404 Page Not Found!',
    oops: 'Uh oh...',
    overview: 'Return to overview',
    complete: 'Continue',
    courseComplete: 'Chapter Complete!',
    chapterComplete: 'Chapter Completed!',
    message: '{count} Message',
    messagePlural: '{count} Messages',
    viewBadge: 'View',
    downloadBadge: 'Download Badge',
    viewBadge2: 'Badge',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Rotate the dials to match the answer',
    fitb: 'Fill in the blank(s)',
    flip: 'Change the number to match the answer',
    multipleChoice: 'Pick the right answer(s)',
    slider: 'Pick the right answer using the slider',
    map: 'Answer the question by tapping the right location on the map',
    dropdown: 'Choose...',
    true: 'True',
    false: 'False',
    arrangeTheWords: 'Click the words in the correct order to complete the sentence, then click Submit:',
    matchTheSentence:
      'Click a phrase on the left, then click its match on the right. Match all pairs to complete the question.',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  cookies: {
    consent: 'AGREE',
    optout: 'Opt out',
    settings: 'Privacy Settings',
    message:
      "You haven't told us anything about your data privacy preferences! That's ok, but we'd like to offer you the best experience using the Sales Companion.",
    disabled: 'It looks like you have disabled the use of cookies.',
    use: 'The {{appName}} requires the use of cookies to deliver you the best experience.',
    details: 'What are the cookies used for?',
    enable: 'See how to enable your cookies {{here}}.',
    here: 'here',
  },
  notLoggedIn: {
    super: "You're not logged in",
    title: 'You need to be logged in to view this content',
    guest: 'Guest',
  },
  demo: {
    message: 'This website is a demo of the final product. It is currently in-development and not a complete product.',
    consent: 'Understood!',
  },
  share: {
    header: 'Share this resource on your favourite social media!',
    download: 'Download',
    button: 'Share',
  },
  sharing: {
    copyURL: 'Copy Link',
    copied: 'Copied',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header: "It looks like you're trying to access the {appName} app from a mobile device",
    body: 'To download this programme simply visit your app store and search for {appName} or click one of the buttons below',
    benefits: {
      header: 'This will provide you with:',
      1: 'Learn, Promote & Sell on the Go',
      2: 'Multimedia Training Across Devices',
      3: 'Certificate of Completion',
      4: 'Ready-made Sales Presentations',
      5: 'High-impact Promotional Materials',
      6: 'Real-time Product Directory',
      7: 'Timely News & Updates',
    },
  },
  directoryView: {
    search: 'Search...',
    amountOfResults: 'Amount of results: ',
    filter: 'Filter',
    filters: 'Filters:',
    subFilter: 'Sub Filter',
    category: 'Category',
    subcategory: 'Subcategory',
    resetFilters: 'Reset Filters',
    showResults: 'Show Results',
    clear: 'Clear',
    noResults: 'No results found. Please try with a different search.',
    resetMap: 'Reset Map to Start >',
    viewNow: 'View Now >',
    viewWebsite: 'Visit website',
    viewOnMap: 'View on map',
    amenities: {
      gym: 'Gym/Fitness Centre',
      spa: 'Spa',
      meeting_room: 'Meeting/Conference Rooms',
      pools: 'Swimming Pool',
      accessible_property: 'Accessible Rooms',
      bars: 'Bar/Lounge',
      golf: 'Golf/Mini-Golf',
      beachfront: 'Private Beach Access',
      restaurants: 'Restaurant',
      waterfront: 'Waterfront',
      villa_product: 'Villa',
      non_smoking_resort: 'Non-Smoking Resort',
      four_star: '4 Star',
      five_star: '5 Star',
      four_star_diamond: '4-Star Diamond',
      five_star_diamond: '5-Star Diamond',
      kitchenette_extended_stay: 'Kitchenette/Extended Stay',
      all_suite: 'All-Suite',
      family_friendly: 'Family Friendly',
      casino: 'Casino',
      downtown: 'Town Centre',
      on_strip: 'On the Strip',
      private_airstrip: 'Private Airstrip',
      fishing_lodge: 'Fishing Lodge',
      dive_center: 'Dive Center',
      selfCatering: 'Self Catering',
      marina: 'Marina',
    },
  },
  directoryProfileView: {
    website: 'Website:',
    phone: 'Phone:',
    address: 'Address:',
    about: 'About:',
    starRating: 'Star Rating:',
    email: 'Email:',
    contactPerson: 'Contact Person:',
    experiences: 'EXPERIENCES',
    accommodationType: 'Accommodation Type:',
    amenitiesNumberOfRooms: 'Number of Rooms: ',
    amenitiesTitle: 'Amenities:',
    socialsTitle: 'SOCIALS:',
    socialTripadvisor: 'TripAdvisor',
    socialYelp: 'Yelp',
    socialYoutube: 'YouTube',
    numberOfRoomsTitle: 'Number of rooms:',
    roomsCount: 'Rooms: {count}',
    listingNotFound: 'Listing not found',
  },
  directory: {
    artsentertainment: 'Arts & Entertainment',
    conventionservices: 'Convention Services',
    divingsnorkeling: 'Diving & Snorkeling',
    film: 'Film',
    hotels: 'Hotels',
    lgbtgymsandspas: 'LGBT+: Gyms and Spas',
    lgbtshopping: 'LGBT+: Shopping',
    lgbtwheretostay: 'LGBT+: Where to Stay',
    multiculturaldining: 'Multicultural: Dining',
    multiculturalnightlife: 'Multicultural: Nightlife',
    nightlife: 'Nightlife',
    petfriendly: 'Pet-Friendly',
    restaurants: 'Restaurants',
    shopping: 'Shopping',
    spas: 'Spas',
    sports: 'Sports',
    transportation: 'Transportation',
    venues: 'Venues',
    waterways: 'Waterways',
    waystoplay: 'Ways to Play',
    weddinglocations: 'Wedding Locations',
    weddingvendors: 'Wedding Vendors',
    attraction: 'Attractions',
    cvb: 'CVBs',
    accommodation: 'Accommodations',
  },
  preregisterview: {},
  custom: {
    splitUsers: 'I Am A ...',
    brandAmbassador: 'Brand Ambassador',
    travelPro: 'Travel Professional',
  },
  rewards: {
    rewards: 'Rewards',
    title: 'Welcome to the Rewards Centre',
    subheader: 'Track and Share Booking Submissions and Rewards',
    titleAmbassador: 'Welcome to the Achievements Centre',
    subheaderAmbassador: 'Track your training achievements, redeem your rewards and share your certifications.',
    lockedPopupNotGraduated:
      'Access these exclusive graduate benefits by completing training and earning your certificate ',
    button: 'Submit your booking',
    products: 'Marketplace',
    viewAllBookings: 'Bookings',
    viewLeaderboard: 'Leaderboard',
    viewDashboard: 'Points Dashboard',
    viewRewards: 'Overview',
    home: {
      entries: 'Current Entries',
      trainingAchievements: 'TRAINING ACHIEVEMENTS',
      trainingAchievementsText:
        'Track your training progress, certifications, and metallic rewards status on this page. You’ll also be able to download and share your diploma, as well as any badges you’ve earned.',
      trainingAchievementsTextNoMetallic:
        'Track your training progress and certifications status on this page. You’ll also be able to download and share your diploma, as well as any badges you’ve earned.',
      bookingContests: 'BOOKINGS DASHBOARD',
      bookingContestsText: 'Easily track and manage current booking submissions on the Bookings Dashboard. ',
      submitBooking: 'SUBMIT BOOKINGS',
      submitBookingText: 'This is where you’ll submit bookings for inclusion in booking contests.',
      currentContest: 'CURRENT CONTEST',
      currentContests: 'CURRENT CONTESTS',
      contestEnterBookings: 'entering your bookings',
      contestNow: ' now!',
      contestSeeOther: 'See other ',
      contestTerms: 'Terms & Conditions',
    },
    bookingRewardsView: {
      title: 'Marketplace',
    },
    bookingsView: {
      title: 'Bookings',
    },
    leaderboardScreen: {
      title: 'POINTS \n Leaderboard',
      earnedpts: 'MY POINTS EARNED​:',
      pointsWall: 'POINTS TOP 5 TRACKER​:',
      startEarning: "Start now earning XP's and join the leaderboard!",
      prizes: 'Prizes',
      tAndC: 'Terms and Conditions apply*',
      pointsOverview: {
        title: 'How to earn points',
        booths: 'Visit Exhibitor Showcases',
        breakoutSessions: 'Attend Breakout Sessions & Destination Spotlights',
        trainingSessions: 'Complete a Chapter',
        adventureSpotlights: 'Family Travel Tips',
        share: 'Sharing Content',
        shareMax: '(up to {maxSharePoints} points)',
        shareInfo:
          'Sharing is counted by sharing booth content to X and Facebook or sharing the entire booth with colleagues or clients.',
        viewVideo: 'View Video',
      },
    },
    dashboardView: {
      title: 'Bookings Dashboard',
      subtitle: 'Track and Manage Your Booking Entries Here.',
      badge: 'Badges',
      activity: 'Bookings Dashboard',
      manage: 'Manage Bookings',
      manageSub:
        'Sort using buttons above and click any record to manage submission details. All pending entries will be verified within 72 hours. ',
      noBookings: 'There are no records to display.',
      state: {
        approvedEntries: 'Approved Entries',
        pendingEntries: 'Pending Entries',
        declinedEntries: 'Declined Entries',
        viewAll: 'View All',
      },
      columns: {
        wholesaler: 'Wholesaler',
        clientLastName: 'Client Last Name',
        totalCostUsd: 'Total Cost USD',
        hotelName: 'Hotel Name',
        hotelConfirmNumber: 'Hotel Confirm #',
        flightNumber: 'Flight #',
        typeOfBooking: 'Type of Booking',
        checkIn: 'Check-In',
        checkOut: 'Check-Out',
        status: 'Status',
      },
    },
    bookingForm: {
      title: 'Booking Submission Form',
      subTitle: 'Enter your booking:',
      required: '* Indicates a required field',
      email: 'Agent Email',
      agentFirstName: 'Agent First Name',
      agentLastName: 'Agent Last Name',
      company: 'Company name',
      iata: 'IATA/CLIA #',
      stateProvince: 'State/ Province',
      postalCode: 'Postcode *',
      country: 'Country',
      bookingNumber: 'Booking Confirm Number',
      numberOfGuests: 'Number of Adult Guests',
      bookingDate: 'Booking Date',
      tourOperator: 'Tour Operator / Booking Method',
      firstName: 'First Name',
      lastName: 'Guest Last Name',
      guestLastName: 'Guest Last Name',
      accommodation: 'Resort/Hotel/Accommodations booked',
      select: 'Select an option',
      wholesaler: 'Wholesaler Name (if applicable): if this is a direct booking, enter NONE',
      arrivalDate: 'Check-In Date',
      departureDate: 'Check-Out Date',
      lengthOfStay: 'Length of Stay (in Nights)',
      totalNights: 'Total Nights',
      reservationNumber: 'Reservation Number',
      rooms: 'Number of Rooms',
      stay: 'Length of Stay (in Nights)',
      airline: 'Airline / Carrier (2- digit code)',
      originAirport: 'Origin Gateway (3- letter airport code)',
      destination: 'Destination/ island (3- letter airport code)',
      cost: 'Total Cost of Booking (only use decimals)',
      totalCost: 'Total Cost',
      file: 'RezSnap™ Proof Upload',
      disclaimer: '* Required fields',
      button: 'Submit your booking',
      sub: 'Your information',
      sub2: 'Booking information',
      guests: 'Number of Passengers',
      numberOfPassengers: 'Number of Passengers',
      accommodationCharterCompany: 'Hotel, Villa, Charter Company',
      propertyCharterCompany: 'Property / Charter Company',
      accommodationBooked: 'Resort/Hotel/Accommodations booked',
      invalidNumber: 'Must be a number greater than 0.',
    },
    bookingFormCustom: {
      app1781: {
        fields: {
          previousVisits: 'Number of Previous Visits to the Mexican Caribbean',
          ambassadorReferralHeader: 'Ambassador Referral',
          referralFirstName: 'First Name',
          referralFirstNamePlaceholder: 'First Name (optional)',
          referralLastName: 'Last Name',
          referralLastNamePlaceholder: 'Last Name (optional)',
          referralEmail: 'Email',
          referralEmailPlaceholder: 'Email (optional)',
        },
      },
      app1439: {
        fields: {
          preOrPostCruise: 'Is this booking for a pre- or post-cruise stay?',
          tripPurpose: 'Trip purpose',
          departureAirport: 'Departure Airport (3- letter airport code)',
        },
      },
    },
    TermsAndConditions: {
      title: 'Terms and Conditions',
      button: 'Return to Rewards',
    },
    thankYouPage: {
      thanks: 'Thank you',
      congrats: 'Congratulations, ',
      body: 'your booking has been received and sent to the campaign supervisor for verification.',
    },
    menu: {
      home: 'Rewards\nCentre',
      homeAmbassador: 'Overview',
      achievements: 'Training\nAchievements',
      bookings: 'Bookings\nDashboard',
      form: 'Submit\nBookings',
    },
  },
  badgeView: {
    title: 'Training Achievements',
    subtitle:
      'Track your training progress, certifications, and metallic rewards status on this page. You’ll also be able to download and share your {program_name_short} diploma, as well as any badges you’ve earned.',
    subtitleNoMetallic:
      'Track your training progress and certifications status on this page. You’ll also be able to download and share your {program_name_short} diploma, as well as any badges you’ve earned.',
    badgeDisplayTitle: 'Metallic Achievement Status',
    badgeAchievement: 'You have achieved {rank} Status! Click the icon on the right to view and share your status.',
    bronze: 'Bronze',
    silver: 'Silver',
    gold: 'Gold',
    platinum: 'Platinum',
    complete: 'COMPLETE',
    diploma: 'Diploma',
    chapterBadges: 'Specialisation Badges',
    partnerBadges: 'Partner Badges',
    tierRewards: 'Tier Rewards',
    click: 'Click ',
    here: 'here',
    bronzeReward: ' to access your exclusive BRONZE reward.',
    silverReward: ' to access your exclusive SILVER reward.',
    goldReward: ' to access your exclusive GOLD reward.',
    bronzeRewardTitle: 'Bronze Status Reward',
    silverRewardTitle: 'Silver Status Reward',
    goldRewardTitle: 'Gold Status Reward',
  },
  badgeDisplay: {
    status: 'Training Achievement Status',
  },
  search: {
    pages: 'Content',
    resources: 'Resources',
  },
  categories: {
    all: 'All',
    accommodations: {
      accommodations: 'Accommodations',
      bedbreakfast: 'Bed & Breakfast',
      campgroundsrvparks: 'Campgrounds & RV Parks',
      condo: 'Condo',
      hotel: 'Hotel',
      vacationrentals: 'Vacation Rentals',
    },
    attractions: 'Attractions',
    dining: 'Dining',
  },
  preregisterView: {
    comingSoon: 'Coming Soon:',
    title: 'The new {appName}',
    success:
      'You have been successfully pre-registered for the programme. You will receive an email when the programme launches.',
    fillRequired: 'Please fill in all the required fields: {fields}',
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    agencyName: 'Agency Name',
    country: 'Country',
    selectDefault: 'Please select an option below',
    requiredFields: '* Required fields',
    submit: 'Submit',
    isRegistered:
      'You have been successfully pre-registered for the programme. You will receive an email when the programme launches.',
    somethingWentWrong: 'Something went wrong. Please try again.',
  },
  profileImageView: {
    currentImage: 'Your current profile image:',
    uploadImage: 'Upload your profile image:',
    chooseAFile: 'Choose a file…',
    cancel: 'cancel',
    backButton: 'Go Back',
    uploadButton: 'Upload profile image',
    saveButton: 'Save this profile image',
    fileTooLargeTitle: 'Uploading size exceeded',
    fileTooLargeText: 'Max image upload size is 10mb',
  },
  FastTrackView: {
    incorrectAnswer: 'That is not correct.',
    question: 'Q{current}/{total}',
    questionCounter: '{current} of {total} questions',
    score: 'Score: {correct}/{total}',
    nextIn: 'Next in {count}s',
    goToNextQuestion: 'Go to next question',
    gradeEarned: 'Grade Earned',
    correct: 'Correct',
    completeFastTrack: 'Complete Fast Track',
    beginFullTraining: 'Begin Full Training',
    fastTrackComplete: 'Fast Track Complete!',
    fastTrackNotPassed: 'Fast Track Not Passed',
    downloadDiploma: 'Download Diploma',
    resultSuccessMessage: "Congratulations — You've passed the Fast Track and earned your diploma!",
    resultAchievementsPrefix: ' You can access your diploma in the ',
    resultAchievementsLinkText: 'Training Achievements',
    resultAchievementsSuffix: ' area.',
    resultFailureMessage:
      "Unfortunately, you didn't pass the Fast Track. It's limited to one attempt per user — but you can still earn your diploma! Work through the full training to build your knowledge and complete at your own pace.",
  },
  smartAssist: {
    title: 'TA SmartAssist',
    pastConversations: 'Past Conversations',
    showNextSuggestionsAria: 'Show next suggestions',
    headingAria: 'Open TA SmartAssist',
    headingResumeAria: 'Resume conversation',
    homePlaceholder: 'Ask anything about travel in {destinationLabel}…',
    recentConversations: 'Recent Conversations',
    previousConversations: 'Previous Conversations',
    noRecentConversations: 'No recent conversations',
    deleteConversationAria: 'Delete conversation',
    chatSubtitle: 'Ask TA Smart Assist Anything About Travel in {destinationLabel}',
    startNewConversationAria: 'Start new conversation',
    sourcesFromApp: 'Sources',
    loadingConversation: 'Loading conversation…',
    welcomePrompt: 'Ask any travel related questions about {destinationLabel}',
    loadingResponse: 'Thinking…',
    messageLimitReached: 'Message limit reached',
    messageRemaining: '{remaining} message remaining',
    messagesRemaining: '{remaining} messages remaining',
    quotaBarAria: '{remaining} of {total} messages remaining',
    resetsAt: 'Resets {resetLabel}',
    quotaChaptersPrompt: 'Earn certification for unlimited usage.',
    chatPlaceholder: 'Ask any travel related questions…',
    greetingFallback: 'Hi there',
    greetingName: 'Hi {firstName}',
    defaultDestination: 'this destination',
    appNotReady: 'App not configured yet.',
    signInRequired: 'Please sign in to continue.',
    genericError: 'Something went wrong. Please try again.',
    requestFailed: 'Request failed. Please try again.',
    sourceFallback: 'Source',
    fallbackSuggestions: {
      bestBeaches: 'Best beaches',
      familyActivities: 'Family activities',
      hiddenGems: 'Hidden gems',
      roadTrips: 'Road trips',
      dining: 'Best dining spots',
      events: 'Upcoming events',
    },
    structured: {
      confidenceThreshold: 'Confidence',
      confidenceThresholdPercentAria: 'Confidence: {percent}%',
      recommendation: 'Recommendation',
      alignment: 'Alignment Check',
      tailor: 'To Tailor Further',
      tips: 'Efficiency Tips',
    },
  },
  imageGallery: {
    noticeTitle: 'Image Usage Notice',
    noticeText: 'All images are licensed exclusively to {clientName} and may not be used without permission',
  },
  toolbox: {
    completion: 'Complete Foundation to unlock this item',
  },
};
